module.exports = __webpack_public_path__ + "img/kronos-logo.4b80e78f.png";